import React, { useEffect } from 'react';
import ConversationalOnboarding from '../../components/OnboardingV2/ConversationalOnboarding/ConversationalOnboarding.tsx';

const Onboarding: React.FC = () => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return <ConversationalOnboarding />;
};

export default Onboarding;
